import { type BreadcrumbItem, siteUrl } from '@config'
import React, { type FC } from 'react'
import {
  type BreadcrumbList,
  type ListItem,
  type WithContext,
} from 'schema-dts'

import { StructuredData } from '../../structured-data/structured-data'

type BreadcrumbsStructuredDataProps = {
  breadcrumbs: BreadcrumbItem[]
}

export const BreadcrumbsStructuredData: FC<BreadcrumbsStructuredDataProps> = ({
  breadcrumbs,
}) => {
  const data: WithContext<BreadcrumbList> = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map(({ name, href }, index) => {
      const isLast = index === breadcrumbs.length - 1
      const hasSlug = href && !isLast
      const listItem: ListItem = {
        '@type': 'ListItem',
        position: index + 1,
        name,
        item: hasSlug ? `${siteUrl}${href}` : undefined,
      }
      return listItem
    }),
  }

  return <StructuredData data={JSON.stringify(data)} />
}
